import { PROJECT_QUERY } from 'containers/Projects/graphql';
import client from 'graphql/client';
import Nprogress from 'nprogress';
import { all, call, put, spawn, takeLatest } from 'redux-saga/effects';
import { ReduxAction } from 'types/redux.types';
import projectsActions from './actions';

function* refreshProjectsListGenerator(action: ReduxAction): any {
  yield call(Nprogress.start);
  const response = yield call(client.query, {
    query: PROJECT_QUERY,
    fetchPolicy: 'no-cache',
    variables: {
      id: action.payload.projectId,
    },
  });
  yield put({
    type: projectsActions.REFRESH_PROJECTS_LIST_DONE,
    payload: response.data.project,
  });
  yield call(Nprogress.done);
}

function* refreshProjectsList() {
  yield takeLatest(projectsActions.REFRESH_PROJECTS_LIST_START, refreshProjectsListGenerator);
}

export default function* rootSaga() {
  yield all([spawn(refreshProjectsList)]);
}
